/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMCAxNlYwSDE2VjE2SDBaTTE1IDE1VjguNUg4LjVWMTVIMTVaTTE1IDFIOC41VjcuNUgxNVYxWk0xIDFWNy41SDcuNVYxSDFaTTEgMTVINy41VjguNUgxVjE1WiIgZmlsbD0iIzdGN0Y3RiIvPjwvc3ZnPg==";